import api from 'data/api';

export const loadSA = api('GET /api/mobile/finance/spendadjustments/:id');

export const approveSA = api(
  'POST /api/mobile/finance/spendadjustments/:id/approve'
);
export const rejectSA = api(
  'POST /api/mobile/finance/spendadjustments/:id/reject'
);
export const moreInfoSA = api(
  'POST /api/mobile/finance/spendadjustments/:id/moreinfo'
);
export const undoSA = api('POST /api/mobile/finance/spendadjustments/:id/undo');
